var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.814,
    height: 22.168,
    viewBox: "0 0 20.814 22.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "journal-text",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_59",
    "data-name": "Trazado 59",
    d: "M5,12.8a.677.677,0,0,1,.677-.677H8.386a.677.677,0,1,1,0,1.354H5.677A.677.677,0,0,1,5,12.8Zm0-2.709a.677.677,0,0,1,.677-.677h6.771a.677.677,0,0,1,0,1.354H5.677A.677.677,0,0,1,5,10.094ZM5,7.386a.677.677,0,0,1,.677-.677h6.771a.677.677,0,0,1,0,1.354H5.677A.677.677,0,0,1,5,7.386ZM5,4.677A.677.677,0,0,1,5.677,4h6.771a.677.677,0,0,1,0,1.354H5.677A.677.677,0,0,1,5,4.677Z",
    transform: "translate(1.771 1.417)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60",
    "data-name": "Trazado 60",
    d: "M3.709,0H17.251A2.709,2.709,0,0,1,19.96,2.709V18.96a2.709,2.709,0,0,1-2.709,2.709H3.709A2.709,2.709,0,0,1,1,18.96V17.606H2.354V18.96a1.354,1.354,0,0,0,1.354,1.354H17.251a1.354,1.354,0,0,0,1.354-1.354V2.709a1.354,1.354,0,0,0-1.354-1.354H3.709A1.354,1.354,0,0,0,2.354,2.709V4.063H1V2.709A2.709,2.709,0,0,1,3.709,0Z",
    transform: "translate(0.354)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_61",
    "data-name": "Trazado 61",
    d: "M1.354,5.354V4.677a.677.677,0,1,1,1.354,0v.677h.677a.677.677,0,1,1,0,1.354H.677a.677.677,0,1,1,0-1.354Zm0,4.063V8.74a.677.677,0,1,1,1.354,0v.677h.677a.677.677,0,0,1,0,1.354H.677a.677.677,0,0,1,0-1.354Zm0,4.063V12.8a.677.677,0,1,1,1.354,0v.677h.677a.677.677,0,0,1,0,1.354H.677a.677.677,0,0,1,0-1.354Z",
    transform: "translate(0 1.417)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalText);
export default __webpack_public_path__ + "static/media/journal-text.79cb4036f61709fa310c263613f08bcb.svg";
export { ForwardRef as ReactComponent };